import './app/prism';
import './app/topics';
import './app/toc';
import './app/reading-progress';
import './app/contact';
import './app/responsive';
import './style.scss';
import Prism from 'prismjs';
Prism.languages.prisma = Prism.languages.extend('clike', {
    keyword: /\b(?:datasource|enum|generator|model|type)\b/,
    'type-class-name': /(\b()\s+)[\w.\\]+/,
});
Prism.languages.javascript['class-name'][0].pattern =
    /(\b(?:model|datasource|enum|generator|type)\s+)[\w.\\]+/;
Prism.languages.insertBefore('prisma', 'function', {
    annotation: {
        pattern: /(^|[^.])@+\w+/,
        lookbehind: true,
        alias: 'punctuation',
    },
});
Prism.languages.insertBefore('prisma', 'punctuation', {
    'type-args': /\b(?:references|fields|onDelete|onUpdate):/,
});
Prism.highlightAll();
